// 为了避免循环引用问题这里只导入基础组件
// 可配置化的组件需要向外暴露可配置的信息，需要在./register-props中声明
import MobileGeneralFormInput from './mobile-general-form-input';
import { component as InputComponent } from './mobile-general-form-input/props';

import MobileGeneralFormPicker from './mobile-general-form-picker';
import { component as PickerComponent } from './mobile-general-form-picker/props';

import MobileGeneralFormOrder from './mobile-general-form-order';
import { component as OrderComponent } from './mobile-general-form-order/props';

import MobileGeneralFormLiveWork from './mobile-general-form-live-work';
import { component as LiveWorkComponent } from './mobile-general-form-live-work/props';

import MobileGeneralFormCityPicker from './mobile-general-form-city-picker';
import { component as CityPickerComponent } from './mobile-general-form-city-picker/props';

import MobileGeneralFormDatetimePicker from './mobile-general-form-datetime-picker';
import { component as DatetimePickerComponent } from './mobile-general-form-datetime-picker/props';

import MobileGeneralFormTextarea from './mobile-general-form-textarea';
import { component as TextareaComponent } from './mobile-general-form-textarea/props';

import MobileGeneralFormCheckbox from './mobile-general-form-checkbox';
import { component as CheckboxComponent } from './mobile-general-form-checkbox/props';

import MobileGeneralFormSingleUpload from './mobile-general-form-single-upload';
import { component as SingleUploadComponent } from './mobile-general-form-single-upload/props';

import MobileGeneralFormIdUpload from './mobile-general-form-id-upload';
import { component as IdUploadComponent } from './mobile-general-form-id-upload/props';

import MobileGeneralFormUpload from './mobile-general-form-upload';
import { component as UploadComponent } from './mobile-general-form-upload/props';

import MobileGeneralFormButton from './mobile-general-form-button';
import { component as ButtonComponent } from './mobile-general-form-button/props';

import MobileGeneralFormHtmlContent from './mobile-general-form-html-content';
import { component as HtmlContentComponent } from './mobile-general-form-html-content/props';

import MobileGeneralFormMobileCaptcha from './mobile-general-form-mobile-captcha';
import { component as MobileCaptchaComponent } from './mobile-general-form-mobile-captcha/props';

import MobileGeneralFormApi from './mobile-general-form-api';
import { component as ApiComponent } from './mobile-general-form-api/props';

import MobileGeneralFormApiInfo from './mobile-general-form-api-info';
import { component as ApiInfoComponent } from './mobile-general-form-api-info/props';

import MobileGeneralFormHiddenVariable from './mobile-general-form-hidden-variable';
import { component as HiddenVariableComponent } from './mobile-general-form-hidden-variable/props';

import MobileGeneralFormNodeText from './mobile-general-form-node-text';
import { component as NodeTextComponent } from './mobile-general-form-node-text/props';

import MobileGeneralFormNodeRadio from './mobile-general-form-node-radio';
import { component as NodeRadioComponent } from './mobile-general-form-node-radio/props';

import MobileGeneralFormNodeLink from './mobile-general-form-node-link';
import { component as NodeLinkComponent } from './mobile-general-form-node-link/props';

import MobileGeneralFormDialog from './mobile-general-form-dialog';
import { component as DialogComponent } from './mobile-general-form-dialog/props';

import MobileGeneralFormAgreement from './mobile-general-form-agreement';
import { component as AgreementComponent } from './mobile-general-form-agreement/props';

import MobileGeneralFormUserSelect from './mobile-general-form-user-select';
import { component as UserSelectComponent } from './mobile-general-form-user-select/props';

// 基础组件
const BASIC_COMPONENT = {
    MobileGeneralFormInput,
    MobileGeneralFormPicker,
    MobileGeneralFormOrder,
    MobileGeneralFormUserSelect,
    MobileGeneralFormLiveWork,
    MobileGeneralFormCityPicker,
    MobileGeneralFormDatetimePicker,
    MobileGeneralFormTextarea,
    MobileGeneralFormCheckbox,
    MobileGeneralFormAgreement,
    MobileGeneralFormButton,
    MobileGeneralFormSingleUpload,
    MobileGeneralFormIdUpload,
    MobileGeneralFormUpload,
    MobileGeneralFormHtmlContent,
    MobileGeneralFormMobileCaptcha,
    MobileGeneralFormApi,
    MobileGeneralFormApiInfo,
    MobileGeneralFormHiddenVariable,
    MobileGeneralFormDialog,
};

const BASIC_COMPONENT_MAP = {
    [InputComponent]: InputComponent,
    [PickerComponent]: PickerComponent,
    [OrderComponent]: OrderComponent,
    [UserSelectComponent]: UserSelectComponent,
    [LiveWorkComponent]: LiveWorkComponent,
    [CityPickerComponent]: CityPickerComponent,
    [DatetimePickerComponent]: DatetimePickerComponent,
    [TextareaComponent]: TextareaComponent,
    [CheckboxComponent]: CheckboxComponent,
    [AgreementComponent]: AgreementComponent,
    [SingleUploadComponent]: SingleUploadComponent,
    [IdUploadComponent]: IdUploadComponent,
    [UploadComponent]: UploadComponent,
    [ButtonComponent]: ButtonComponent,
    [HtmlContentComponent]: HtmlContentComponent,
    [MobileCaptchaComponent]: MobileCaptchaComponent,
    [ApiComponent]: ApiComponent,
    [ApiInfoComponent]: ApiInfoComponent,
    [HiddenVariableComponent]: HiddenVariableComponent,
    [DialogComponent]: DialogComponent,
};

const LIST_COMPONENT_MAP = {
    [NodeTextComponent]: NodeTextComponent,
    [NodeRadioComponent]: NodeRadioComponent,
    [NodeLinkComponent]: NodeLinkComponent,
};

// 复杂组件：容器与复制器
import { component as ContainerComponent } from './mobile-general-form-container/props';
import { component as ArrayComponent } from './mobile-general-form-array/props';
import { component as ListContainerComponent } from './mobile-general-form-list-container/props';

// 这里可以把全部组件注册上
export const COMPONENT_MAP = {
    // 基础组件的映射
    ...BASIC_COMPONENT_MAP,
    ...LIST_COMPONENT_MAP,

    // 可嵌套的组件特殊处理，写明映射但是不引入
    [ContainerComponent]: ContainerComponent,
    [ArrayComponent]: ArrayComponent,
    [ListContainerComponent]: ListContainerComponent,
};

// 为避免循环引用，这里只包含不会出现组件嵌套的通用表单组件
export const SIMPLE_COMPONENT = {
    ...BASIC_COMPONENT,
};

// mobile-general-form-list-container 需要引入的组件
export const LIST_COMPONENT = {
    MobileGeneralFormNodeText,
    MobileGeneralFormNodeRadio,
    MobileGeneralFormNodeLink,
};
